import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B000222FindRequest = Partial<{
  zoneCd: string;
  kana: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000222FindResponse = {
  sokoCd: string;
  zoneCd: string;
  zoneNm: string;
  zoneKana: string;
  floor: string;
};

export const B000222Find = (props: B000222FindRequest) => {
  return RestClient.get<PageableResponse<B000222FindResponse[]>>(
    "b000222/find",
    {
      params: props,
    }
  );
};
